/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MfaMethod = {
    Authenticator: 'authenticator',
    Email: 'email'
} as const;
export type MfaMethod = typeof MfaMethod[keyof typeof MfaMethod];


export function MfaMethodFromJSON(json: any): MfaMethod {
    return MfaMethodFromJSONTyped(json, false);
}

export function MfaMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): MfaMethod {
    return json as MfaMethod;
}

export function MfaMethodToJSON(value?: MfaMethod | null): any {
    return value as any;
}

